import React from "react";
import {Button, Checkbox, Form, Input, message} from "antd";
import {request} from "../utils/utils";

interface LoginProps {
    onLoginSuccess: (token:String) => void
}

export default class Login extends React.Component<LoginProps, any> {
    layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
    };
    tailLayout = {
        wrapperCol: { offset: 8, span: 16 },
    };

    onFinish = (values: any) => {
        const form = new FormData()
        form.append("userName", values.username)
        form.append("password", values.password)
        request({
            method: "POST",
            url: "/gateway/user/login",
            data: form
        }).then(res => {
            this.props.onLoginSuccess(res.data)
        }).catch(()=> {
            message.error("登录失败，请稍后重试")
        })
    };

    render() {
        return (
            <Form
                {...this.layout}
                name="basic"
                initialValues={{ remember: true }}
                onFinish={this.onFinish}
            >
                <Form.Item label="Username" name="username" rules={[{ required: true, message: '请输入用户名' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Password" name="password" rules={[{ required: true, message: '请输入密码' }]} >
                    <Input.Password />
                </Form.Item>
                <Form.Item {...this.tailLayout} name="remember" valuePropName="checked">
                    <Checkbox>Remember me</Checkbox>
                </Form.Item>
                <Form.Item {...this.tailLayout}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}
